/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import {
  CLEAR_SELECTED_ROLES,
  REMOVE_UNSELECTED_ROLES,
  UPDATE_SELECTED_ROLES,
} from '../actions/bulkRoleSelectAction';

const initialState = {
  selectedRoles: [],
};

const bulkSelectedRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_ROLES:
      // Check if role already exists in the array
      const roleExists = state.selectedRoles.some(
        (role) => role.roleKey === action.payload.roleKey
      );

      if (roleExists) {
        // Remove the role if it already exists
        return {
          ...state,
          selectedRoles: state.selectedRoles.filter(
            (role) => role.roleKey !== action.payload.roleKey
          ),
        };
      }

      return {
        ...state,
        selectedRoles: [...state.selectedRoles, action.payload],
      };
    case REMOVE_UNSELECTED_ROLES:
      const { payload } = action;

      return {
        ...state,
        selectedRoles: payload.filter((role) => role.isChecked),
      };
    case CLEAR_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: [],
      };
    default:
      return state;
  }
};

export default bulkSelectedRoleReducer;
